'use client';

import {
  Divider,
  IcGraphicCooperation,
  IcGraphicFee,
  IcGraphicResearch,
  Padding,
  Typography,
} from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { BenefitCouponIcon } from '../components/BenefitIcons';
import { BenefitItem } from '../components/BenefitItem';
import { getIntroContent } from '../introContent';

const BENEFIT_ICONS = [
  <IcGraphicFee key="fee" width={56} height={56} />,
  <BenefitCouponIcon key="coupon" />,
  <IcGraphicResearch key="research" width={56} height={56} />,
  <IcGraphicCooperation key="cooperation" width={56} height={56} />,
];

export const IntroBenefitsSection = () => {
  const { service } = useDeviceInfo();
  const { benefits } = getIntroContent(service);

  return (
    <div className="px-4">
      <Padding bottom="4">
        <Typography variant="title20pxMed">큐레이터 선정 혜택</Typography>
      </Padding>

      <div className="py-2 bg-gray-100 rounded">
        <div className="flex flex-col">
          {benefits.map((benefit, index) => (
            <BenefitItem key={index} {...benefit} icon={BENEFIT_ICONS[index]} />
          ))}
        </div>
      </div>

      <Padding y="8">
        <Divider variant="line" colorScheme="gray-500" />
      </Padding>
    </div>
  );
};
